import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Auth } from '@aws-amplify/auth';

import { from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          return from(Auth.signOut()).pipe(
            switchMap(() => throwError(() => err))
          );
        }

        // Wenn es ein 404 ist, wandeln wir den FEHLER in ein REINES OBJEKT um.
        // Dadurch denkt Raygun (und RxJS), der Request war "erfolgreich",
        // nur eben mit leerem Inhalt.
        if (err.status === 404) {
          console.log(`Webcam 404 ignoriert für URL: ${err.url}`);
          return of(new HttpResponse({ status: 200, body: null }));
        }

        return throwError(() => err);
      })
    );
  }
}
